import { cloneDeep, findIndex } from "lodash";
import {
  GET_MODULE_SETTING_ERROR,
  GET_TEACHING_ASSISTANT_SUCCESS,
  UPDATE_TEACHING_ASSISTANT_SUCCESS,
} from "../constants";

export const initialState = {
  teachingAssistant: undefined,
};
export const TeachingAssistantReducer = (state = initialState, action) => {
  //switch between action.type
  switch (action.type) {
    case GET_TEACHING_ASSISTANT_SUCCESS: {
      return {
        ...state,
        teachingAssistant: action.payload,
      };
    }
    case GET_MODULE_SETTING_ERROR: {
      return {
        ...state,
        teachingAssistant: undefined,
      };
    }

    case UPDATE_TEACHING_ASSISTANT_SUCCESS: {
      const tempcategories = cloneDeep(state.teachingAssistant);
      const index = findIndex(
        tempcategories.data,
        (obj) => obj._id === action.payload._id
      );

      if (index !== -1) {
        tempcategories.data[index] = action.payload;
      }

      return {
        ...state,
        teachingAssistant: tempcategories,
      };
    }

    default:
      return state;
  }
};
